<template>
  <div
    @click="onClick"
    class="h-[55px] px-2 flex items-center justify-between overflow-hidden border-b border-gray-100"
  >
    <div class="w-full overflow-hidden *:overflow-hidden *:whitespace-nowrap *:text-ellipsis *:leading-tight">
      <div class="text-sm font-medium text-gray-700">{{ repeaterIdStr }}</div>
      <div class="text-xs font-medium text-gray-500">{{ repeater.description }}</div>
    </div>
    <div class="text-gray-500 *:ml-2 flex h-full items-center">
      <i :class="[status.icon, iconColorClass]" class="text-xl"></i>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSelectedProperty } from '@/stores/selected-property.store';
import { createAnimation, useIonRouter } from '@ionic/vue';
import { Repeater, NextLink, DeviceStatus } from '@ncss/models/dist/v3';
import { ConversionUtils } from '@ncss/models';
import { computed } from 'vue';

const props = defineProps<{ repeater: Repeater | NextLink }>();
const router = useIonRouter();
const selectedProperty = useSelectedProperty();
const repeaterIdStr = computed(() =>
  props.repeater.id ? ConversionUtils.ConvertSerialNumberToString(props.repeater.id) : ''
);
const status = computed<DeviceStatus>(() => {
  return props.repeater.computeStatus({} as any);
});
const iconColorClass = computed<'text-green-500' | 'text-red-500' | 'text-gray-500'>(() => {
  const s = status.value;
  if (s.icon === 'icon-check') {
    return 'text-green-500';
  } else if (s.icon === 'icon-minus') {
    return 'text-gray-500';
  }
  return 'text-red-500';
});

function onClick() {
  return router.push(`/repeater/${selectedProperty.propertyId}/${props.repeater.id}`);
}
</script>
